import { useElementSize } from '@vueuse/core';
import { ref, onMounted } from 'vue';

export const useHeaderHeight = () => {
  const useHeaderH = () => {
    const header = ref(document.getElementsByClassName('header')[0]);

    onMounted(() => {
      header.value = document.getElementsByClassName('header')[0];
    });

    const { height: headerHeight } = useElementSize(header);

    return headerHeight;
  };

  const useNotificationsH = () => {
    const notifications = ref(
      document.getElementsByClassName('notificationTicker')[0],
    );

    onMounted(() => {
      notifications.value =
        document.getElementsByClassName('notificationTicker')[0];
    });

    const { height: notificationsHeight } = useElementSize(notifications);

    return notificationsHeight;
  };
  const useBreadcrumbsH = () => {
    const breadcrumbs = ref(
      document.getElementsByClassName('notificationTicker')[0],
    );

    onMounted(() => {
      breadcrumbs.value =
        document.getElementsByClassName('breadcrumbs')[0];
    });

    const { height: breadcrumbsHeight } = useElementSize(breadcrumbs);

    return breadcrumbsHeight;
  };

  return {
    useHeaderH,
    useNotificationsH,
    useBreadcrumbsH
  };
};
